import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../../actions';
import { Form, Input, Icon, Button } from 'antd';
import RowMainContent from './RowMainContent';
import { isEmpty } from '../../../util/isEmpty';

let id = 1;

/**
 * @component
 * @category Form Page
 * @subcategory FCL Tab
 * @name FCLMainContentFieldSet
 * @description It's FCL shipping component
 * <br> <br>
 * **Example**
 * ```js
 *   <FCLMainContentFieldSet />
 * ```
 */
class FCLMainContentFieldSet extends React.Component {
  state = {
    initKeys: [0],
  };
  componentDidMount = () => {
    //get old rows
    const { fclShipping } = this.props;
    if (!isEmpty(fclShipping)) {
      let keys = Object.keys(fclShipping);
      keys = keys.map((key) => fclShipping[key] && Number(key));
      this.setState({ initKeys: keys });
    }
  };

  /**
   * @description when a FCL load is removed, this method is invoked
   * <br> <br>
   * **remove(k) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | k             | number        | `id`/`key` of the load e.g. `2` |

   * Returns: Type: void
   */
  remove = (k) => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    // We need at least one passenger
    if (keys.length === 1) {
      return;
    }

    form.setFieldsValue({
      keys: keys.filter((key) => key !== k),
    });
  };

  /**
   * @description when a FCL load is added, this method is invoked
   * <br> <br>
   * **add() -> {void}**
   * <br><br>
   * Returns: Type: void
   */
  add = () => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys,
    });
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { initKeys } = this.state;

    getFieldDecorator('keys', { initialValue: initKeys });
    const keys = getFieldValue('keys');
    // console.log("keys: ", keys);

    const formItems = keys.map((k, index) => (
      <Form.Item required={false} key={`${k}-${index}`} className="testO1">
        <div
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
          className="testBla1"
        >
          <div className="testBla1">
            {getFieldDecorator(`names[${k}]`, {
              // validateTrigger: ["onChange", "onBlur"],
              rules: null,
            })(
              <div {...{ form: this.props.form }}>
                <RowMainContent rowId={k} />
              </div>
            )}
          </div>
          <div className="testBlu1">
            {keys.length > 1 ? (
              <Icon
                type="delete"
                theme="filled"
                onClick={() => this.remove(k)}
              />
            ) : null}
          </div>
        </div>
      </Form.Item>
    ));
    return (
      <Form
        //   onSubmit={this.handleSubmit}
        className="testR1"
      >
        <div className="testO1"> {formItems}</div>
        <div style={{ height: '42px' }}>
          <hr
            style={{
              borderColor: '#ffdfac',
              height: '2px',
              border: 0,
              borderTop: '1px solid rgb(197, 217, 232)',
            }}
          />
          <Form.Item
            style={{ height: 'auto', cursor: 'pointer', width: '100px' }}
            className="testR1"
          >
            <div onClick={this.add} className="testR1" style={{}}>
              <span>
                <Icon
                  type="plus-circle"
                  theme="filled"
                  size={13}
                  style={{ color: '#0093ee' }}
                />
              </span>

              <span
                style={{
                  fontSize: '13px',
                  color: '#627b93',
                  width: '50px',
                  marginLeft: '10px',
                }}
              >
                Add load
              </span>
            </div>
          </Form.Item>
        </div>
        {/* <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item> */}
      </Form>
    );
  }
}

FCLMainContentFieldSet.propTypes = {
  /**
   * fcl shipping data
   */
  fclShipping: PropTypes.object,
};

const MainContent = Form.create({ name: 'form_shipping_right' })(
  FCLMainContentFieldSet
);

const mapStateToProps = (state) => {
  return {
    fclShipping: state.form.fclShipping,
  };
};

export default connect(mapStateToProps)(MainContent);
